import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from "react";
import Button from "components/atom/button/Button.tsx";
import dayjs from "dayjs";
import Modal from "components/atom/Modal.tsx";

const STORAGE_APP_BANNER_KEY = "app-banner-settings";
const VERSION = "2.0.2";
const WAIT_TIME = 5000;//5 seconds
const RESHOW_IN_DAYS = 3;

const APP_STORE_URL = "https://apps.apple.com/ca/app/bethere/id6764127749";
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=app.betheremap.bethereapp";
const GOOGLE_PLAY_MARKET_URL = "market://details?id=app.betheremap.bethereapp";

function MobileAppInstallBanner() {
  const { t } = useTranslation();
  const [showBanner, setShowBanner] = useState<boolean>(false);
  const timeoutId = useRef<any>();

  const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  const isIos = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  useEffect(() => {
    if (!isMobile) {
      return;
    }

    const bannerSettingsJson = window.localStorage.getItem(STORAGE_APP_BANNER_KEY);
    if (bannerSettingsJson) {
      try {
        const bannerSettings = JSON.parse(bannerSettingsJson);
        if (bannerSettings && typeof bannerSettings === "object") {
          if ("version" in bannerSettings) {
            // If user has dismissed the banner and it's not expired, don't show it
            //@ts-ignore
            if (bannerSettings.version === VERSION && bannerSettings.dismissed && now.diff(dayjs(bannerSettings.createdAt), "day") < RESHOW_IN_DAYS) {
              return;
            }
          }
        }
      } catch {
        // show banner on parse error
      }
    }

    timeoutId.current = setTimeout(() => {
      setShowBanner(true);
    }, WAIT_TIME);

    return () => clearTimeout(timeoutId.current);
  }, [isMobile]);

  const dismissBanner = () => {
    window.localStorage.setItem(STORAGE_APP_BANNER_KEY, JSON.stringify({
      dismissed: true,
      version: VERSION,
      createdAt: dayjs().format("YYYY-MM-DD HH:mm:ss")
    }));
    setShowBanner(false);
  };

  const openStore = () => {
    if (isIos) {
      window.open(APP_STORE_URL, "_blank", "noopener,noreferrer");
    } else {
      // Try to open Play Store app via market:// scheme, fall back to web URL
      window.location.href = GOOGLE_PLAY_MARKET_URL;
      setTimeout(() => {
        window.open(GOOGLE_PLAY_URL, "_blank", "noopener,noreferrer");
      }, 1500);
    }
    dismissBanner();
  };

  if (!showBanner) {
    return null;
  }

  return (
    <Modal
      position="bottom"
      flexibleHeight
      className="-app-install-banner animate-slide-up"
      onClose={dismissBanner}>
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="flex flex-col items-center justify-center">
          <h2 className="text-2xl text-center pb-3 font-bold">
            {t("popup.mobileapp.title")}
          </h2>
          <p className="-small pt-1 text-center">
            {t("popup.mobileapp.description")}
          </p>
        </div>
        <div className="w-full xs:w-3/4 flex flex-col items-center justify-center gap-4">
          <Button className="w-full" type="submit" onClick={openStore}>
            {isIos ? t("popup.mobileapp.appStore") : t("popup.mobileapp.googlePlay")}
          </Button>
          <Button className="w-2/3 mx-auto" style="border" small onClick={dismissBanner}>
            {t("popup.mobileapp.later")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default MobileAppInstallBanner;
